// Campos da ficha do contato. O modelo (templates) vem da empresa e os valores
// ficam em contact.extraInfo ({ id, name, value }), ligados pelo nome.

const keyOf = (name) => String(name || "").trim().toLowerCase();
const hasValue = (value) => String(value ?? "").trim() !== "";

/**
 * Separa o que mostrar na ficha:
 * - alerts: campos de alerta preenchidos (na ordem do modelo)
 * - fields: demais campos preenchidos — primeiro os do modelo, depois os livres
 */
export const splitContactFields = (extraInfo = [], templates = []) => {
  const infos = (extraInfo || []).filter((info) => hasValue(info.value));
  const used = new Set();
  const alerts = [];
  const fields = [];

  templates.forEach((template) => {
    const info = infos.find(
      (item) => !used.has(item) && keyOf(item.name) === keyOf(template.name)
    );
    if (!info) return;
    used.add(info);
    const entry = { id: info.id, name: template.name, value: info.value };
    (template.isAlert ? alerts : fields).push(entry);
  });

  infos.forEach((info) => {
    if (!used.has(info)) fields.push({ id: info.id, name: info.name, value: info.value });
  });

  return { alerts, fields };
};

/**
 * Prepara o formulário: um item por campo do modelo (com o valor atual, se
 * houver) e o restante como informação livre.
 */
export const toFormFields = (extraInfo = [], templates = []) => {
  const infos = [...(extraInfo || [])];
  const templateValues = templates.map((template) => {
    const index = infos.findIndex((item) => keyOf(item.name) === keyOf(template.name));
    const info = index >= 0 ? infos.splice(index, 1)[0] : null;
    return {
      id: info?.id,
      name: template.name,
      isAlert: Boolean(template.isAlert),
      value: info?.value ?? "",
    };
  });
  return { templateValues, freeInfo: infos };
};

/**
 * Junta de volta para salvar: campos do modelo vazios não são gravados (e,
 * se existiam, são removidos pelo backend por não virem na lista).
 */
export const fromFormFields = (templateValues = [], freeInfo = []) => [
  ...templateValues
    .filter((field) => hasValue(field.value))
    .map((field) => ({
      ...(field.id ? { id: field.id } : {}),
      name: field.name,
      value: String(field.value).trim(),
    })),
  ...(freeInfo || []),
];
